/**
 * Lookup payloads may use mixed property names for the public site URL.
 * When no URL is present, falls back to the in-app nonprofit profile (same idea as {@link NonProfit} cards).
 */
const URL_KEYS = [
  'website',
  'Website',
  'nonprofitUrl',
  'NonprofitUrl',
  'webSite',
  'WebSite',
  'nonprofitCardUrl',
  'NonprofitCardUrl',
] as const

const EXTERNAL_ID_KEYS = ['externalId', 'ExternalId'] as const

function buildCatalogFallbackHref(externalId: string): string {
  const id = externalId.trim()
  const path = `/external/${encodeURIComponent(id)}?externalId=${encodeURIComponent(id)}`
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '')
  return base ? `${base}${path}` : path
}

export function resolveNonprofitWebsiteHref(entity: unknown): string {
  if (!entity || typeof entity !== 'object') {
    return ''
  }
  const record = entity as Record<string, unknown>

  const urlKey = URL_KEYS.find((k) => {
    const v = record[k]
    return typeof v === 'string' && v.trim()
  })
  if (urlKey !== undefined) {
    const v = record[urlKey]
    return typeof v === 'string' ? v.trim() : ''
  }

  const extKey = EXTERNAL_ID_KEYS.find((k) => {
    const v = record[k]
    return typeof v === 'string' && v.trim()
  })
  if (extKey !== undefined) {
    const v = record[extKey]
    return typeof v === 'string' ? buildCatalogFallbackHref(v) : ''
  }

  return ''
}
